import 'magnific-popup'


export default {
	init() {


		// const $reservationFormPopup = $("#reservation-form-popup")
		// if ($reservationFormPopup.length) {
		// 	$reservationFormPopup.magnificPopup({
		// 		type: "inline",
		// 		preloader: false,
		// 		focus: "#ime",
		// 	})
		// }
		
		$(".popup-with-form").magnificPopup({
			type: "inline",
			preloader: false,
			focus: "#ime",

			modal: true, // Spremenjeno pred TR
			// closeOnBgClick: true, // Dodano pred TR
			// closeOnContentClick: true, // Dodano pred TR

			// When elemened is focused, some mobile browsers in some cases zoom in
			// It looks not nice, so we disable it:
			callbacks: {
				beforeOpen: function () {
					if ($(window).width() < 700) {
						this.st.focus = false
					} else {
						this.st.focus = "#ime"
					}
				},
			},
		})
		// $(document).on("click", ".popup-modal-dismiss", function (e) {
		// 	e.preventDefault()
		// 	$.magnificPopup.close()
		// })
	}
}
